/**
 * Subdomínios que nunca são marca. O app não usa slug no path (A005), então
 * a lista é curta: infra e os próprios ambientes.
 *
 * `ensaio` é o hostname de pré-produção da virada (DEPLOY-PRODUCAO.md, item
 * 7): `ensaio.app.evasaude.com.br` aponta para o site novo antes de
 * `app.evasaude.com.br` virar, porque o CORS de produção só aceita
 * `*.evasaude.com.br` e o `.web.app` não serve para validar. Reservado para
 * cair na Eva em vez de ser procurado como marca.
 */
export const RESERVED_SUBDOMAINS: readonly string[] = ['www', 'api', 'admin', 'admin-qa', 'app', 'app-qa', 'ensaio', 'static', 'assets'];

/** Prefixos de rota do app. Um portal novo entra aqui. */
export const PORTAL_PREFIXES: readonly string[] = ['pro', 'marca', 'empresa', 'eu'];
